const menuConfig = [
  {
    // name: 'general',
    // path: '/general',
    options: [
      {
        // name: 'openingFunds',
        // path: '/opening-funds',
      },
      {
        // name: 'accountProfiles',
        // path: '/account-profiles',
      },
    ],
  },
];

export default menuConfig;
